<!--  -->

<template>
  <div class="count">
    <div class="count1">
      <div class="text">总运力数</div>
      <span class="figure">{{ topLeftData.totalCapacity }}</span>
      <span class="text">辆</span>
    </div>
    <div class="count1">
      <div class="text">总车队数</div>
      <span class="figure">{{ topLeftData.totalFleet }}</span>
      <span class="text">家</span>
    </div>
    <div class="count1">
      <div class="text">总订单量</div>
      <span class="figure">{{ topLeftData.totalOrder }}</span>
      <span class="text">车</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    topLeftData: {
      type: Object,
      default: function () {
        return {
          totalCapacity: 0,
          totalFleet: 0,
          totalOrder: 0
        };
      }
    }
  },

  data () {
    return {};
  },
  computed: {},
  watch: {
    topLeftData: {
      handler (data) { },
      deep: true
    }
  },
  created () { },
  mounted () { },
  methods: {}
};
</script>

<style scoped>
.count {
  width: 90%;
  height: 20%;
  padding: 0 5%;
  background-image: url('../assets/img/左一bg.png'), url('../assets/img/左1line1.png'), url('../assets/img/左1line1.png');
  /* background: rgb(245, 129, 129); */
  background-repeat: no-repeat, no-repeat;
  background-position: top, 35%, 65%;
  background-size: 100% 100%, 1px 60%, 1px 60%;
}
.count .count1 {
  float: left;
  text-align: center;
  height: 70%;
  width: 33%;
  margin: 0 auto;
  padding-top: 15%;
}
.count .count1 .text {
  color: aliceblue;
  padding-bottom: 10px;
  font-size: 15px;
}
.count .count1 .figure {
  color: #fdce51;
  font-size: 30px;
  font-family: 'DIN Alternate';
}
</style>



// WEBPACK FOOTER //
// src/components/count.vue